import React, {useState} from 'react';
import {useAuth} from '../model/AuthContext';
import {useNavigate} from 'react-router-dom';
import {commonStyles, theme} from '../../../shared/lib/styles';
import { AppDecorBackground } from '../../../shared/ui';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(() =>
        sessionStorage.getItem('landgraf:access_expired_message') || ''
    );
    const [loading, setLoading] = useState(false);
    const {login} = useAuth();
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        sessionStorage.removeItem('landgraf:access_expired_message');
        setError('');
        const result = await login(username, password);
        if (result.success) {
            navigate('/dashboard');
        } else {
            setError(result.error);
        }
        setLoading(false);
    };

    const logoUrl = `${process.env.PUBLIC_URL || ''}/logo192.png`;

    return (
        <div style={styles.container}>
            <AppDecorBackground />
            <div style={styles.card}>
                <div style={styles.logoBlock}>
                    <img src={logoUrl} alt="Landgraf" style={styles.logo} />
                    <h1 style={styles.brandName}>Landgraf</h1>
                </div>

                <form onSubmit={handleSubmit} style={commonStyles.form}>
                    {error && <div style={commonStyles.error}>{error}</div>}

                    <div style={commonStyles.inputGroup}>
                        <input
                            type="text"
                            placeholder="Имя пользователя"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            disabled={loading}
                            style={commonStyles.input}
                        />
                    </div>

                    <div style={commonStyles.inputGroup}>
                        <input
                            type="password"
                            placeholder="Пароль"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={loading}
                            style={commonStyles.input}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={styles.button}
                    >
                        {loading ? 'Вход...' : 'Войти'}
                    </button>
                </form>

                <div style={styles.info}>
                    <p>Для доступа обратитесь к администратору</p>
                </div>
            </div>
        </div>
    );
};

// Используем общие стили и тему, добавляя специфичные стили для этого компонента
const styles = {
    container: {
        ...commonStyles.containerCentered,
        position: 'relative',
        backgroundColor: 'transparent',
        backgroundImage: `linear-gradient(rgba(30, 25, 18, 0.35), rgba(30, 25, 18, 0.45)), url(${process.env.PUBLIC_URL || ''}/design/bg-title.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    card: {
        ...commonStyles.card,
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: '400px',
        padding: theme.spacing.xl,
        backgroundColor: 'rgba(245, 235, 214, 0.94)',
    },
    logoBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing.lg,
    },
    logo: {
        width: 80,
        height: 80,
        objectFit: 'contain',
        marginBottom: theme.spacing.sm,
    },
    brandName: {
        margin: 0,
        fontSize: theme.fontSize['3xl'],
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.brandTeal,
        letterSpacing: '0.02em',
    },
    title: {
        ...commonStyles.title,
        textAlign: 'center',
        marginBottom: theme.spacing.xl,
        fontSize: theme.fontSize['2xl'],
    },
    button: {
        ...commonStyles.button,
        ...commonStyles.buttonPrimary,
        marginTop: theme.spacing.sm,
        width: '100%',
    },
    info: {
        textAlign: 'center',
        marginTop: theme.spacing.lg,
        paddingTop: theme.spacing.lg,
        borderTop: `1px solid ${theme.colors.borderLight}`,
        color: theme.colors.textLight,
        fontSize: theme.fontSize.sm,
    }
};

export default Login;

